import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { register as registerSwiper } from 'swiper/element/bundle';

registerSwiper();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(private platform: Platform) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {});
  }
}
